import { CdkService, UpdateInspectionsVehicleRequest, VehicleInspectionType } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';

export type UpdateVehicleInspectionDatesInput = {
  branchId: number;
  vehicleId: string;
  type?: VehicleInspectionType;
  lastDate?: string | null;
  dueDate?: string | null;
};

const CDK_AUDIT_DATA = {
  userId: 'api-1588',
  userName: 'QS API'
};

export const useUpdateVehicleInspectionDatesMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof CdkService.postCdkVehiclesVehicleUpdateInspectionDates>>,
      QueryError,
      UpdateVehicleInspectionDatesInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation((input: UpdateVehicleInspectionDatesInput) => {
    const requestBody: UpdateInspectionsVehicleRequest = {
      metadata: {
        auditData: CDK_AUDIT_DATA
      },
      type: input.type,
      lastDate: input.lastDate,
      dueDate: input.dueDate
    };
    return CdkService.postCdkVehiclesVehicleUpdateInspectionDates(input.branchId, input.vehicleId, requestBody);
  }, options);
